module.exports = __webpack_public_path__ + "img/tips8.24bf4d17.png";